import { useEffect } from 'react';
export function useEscapeKey(callback, enabled = true) {
    useEffect(() => {
        if (!enabled)
            return;
        function handleKeyDown(event) {
            if (event.key === 'Escape') {
                callback();
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [callback, enabled]);
}
//# sourceMappingURL=useEscapeKey.js.map